import React, { Suspense } from "react";

import HdLoader from "@hd/ui-kit/hd-loader/HdLoader";
import HdModal from "@hd/ui-kit/hd-modal/HdModal";

import { useRequestModalStore } from "./request-modal.store";

const RequestModalContent = React.lazy(
  () => import("./components/RequestModalContent")
);
function RequestModal() {
  const { isOpen, close } = useRequestModalStore();

  return (
    <HdModal
      backdrop={true}
      isOpen={isOpen}
      closeOnEsc={true}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          close();
        }
      }}
      zIndex={40}
      // closeOnClickOutside={false}
      className="p-2 bg-white w-[900px] min-h-[85vh] flex flex-col"
    >
      {isOpen && (
        <Suspense fallback={<HdLoader></HdLoader>}>
          <RequestModalContent></RequestModalContent>
        </Suspense>
      )}
    </HdModal>
  );
}

export default RequestModal;
